import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import router from '@/router'

export default () => {
  const isProd = process.env.NODE_ENV === 'production'

  return {
    init: () => {
      Sentry.init({
        Vue,
        dsn: 'https://8eceaac76c2f4a3f9deed713fb5eda90@o77954.ingest.sentry.io/168995',
        environment: process.env.NODE_ENV,
        release: 'readgraphy@' + process.env.appVersion,
        beforeSend: (ev) => {
          return isProd || process.env.NODE_ENV === 'staging' ? ev : null
        },
        integrations: [
          new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ['localhost', 'readgraphyapp.com', /^\//]
          })
        ],
        tracesSampleRate: 1.0
      })
    },
    setUser: (user) => {
      if (!user) {
        Sentry.configureScope((scope) => scope.setUser(null))
        return
      }

      Sentry.setUser({ id: user.uid, email: user.email })
    }
  }
}
